import axios from 'axios';

const onboarding = axios.create({
  baseURL: process.env.REACT_APP_ONBOARDING_URL,
});

export { onboarding };
